// load styles for custom button plugin in reader mode
import {customButtonStyles} from "@/components/tinyMce/plugins/customButton/styles/custom-button-styles";

const loadButtonViewModeAssets = (doc: Document = document) => {
  const buttonViewModeStylesId = 'custom-button-viewmode-styles';
  if (!doc.getElementById(buttonViewModeStylesId)) {
    const themeMainColor = getComputedStyle(document.documentElement).getPropertyValue('--themeMainColor')?.trim();
    const style = doc.createElement('style');
    style.id = buttonViewModeStylesId;
    style.textContent = ` ${customButtonStyles}
                            :root { --themeMainColor: ${themeMainColor}; }
                           .tmce-plugin-custom-button--primary:hover {
                              background-color: color-mix(in srgb, var(--themeMainColor) 90%, black) !important;
                            }
                          `;
    doc.head.appendChild(style);
  }
};

export default {
  loadButtonViewModeAssets,
}
